import React from 'react';

function NoDataForSelection() {
    return (
        <div className="flex justify-center items-center">
            <span className="text-word text-center font-medium">
                No data available for the filter selection,
                <br /> Please select from filter.
            </span>
        </div>
    );
}

export default NoDataForSelection;
